<!-- 系统-设置 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea APIManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索区域 -->
        <div class="searchArea clearfix">
          <el-input
            class="searchInput"
            placeholder="请输入API名称"
            v-model="apiData.paging.search_str"
            clearable></el-input>
          <el-select
            class="searchSelect"
            placeholder="请选择请求类型"
            v-model="apiData.paging.post_type">
            <el-option label="请选择请求类型" value=""></el-option>
            <el-option label="get" value="get"></el-option>
            <el-option label="post" value="post"></el-option>
          </el-select>
          <el-button
            class="searchBtn"
            type="primary"
            @click="getApiList('search')">搜 索</el-button>
        </div>
        
        <!-- 添加按钮 -->
        <el-button class="addBtn" type="primary" @click="operateDialogInfo('add')">添 加</el-button>

        <!-- API列表 -->
        <el-table
          :data="apiData.list"
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            prop="name"
            label="API名称">
          </el-table-column>
          <el-table-column
            prop="type"
            label="类型">
          </el-table-column>
          <el-table-column
            prop="url"
            label="地址"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="param"
            label="参数">
          </el-table-column>
          <el-table-column
            prop="post_type"
            label="请求类型">
          </el-table-column>
          <el-table-column
            prop="desc"
            label="描述"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="operateDialogInfo('alter',scope.row)">修改</el-button>
              <el-button type="text" @click="operateDialogInfo('delete',scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="paging" v-if="apiData.pageCount > 1">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="apiData.paging.page"
            layout="prev, pager, next, jumper"
            :page-count="apiData.pageCount">
          </el-pagination>
        </div>

        <!--对话框-->
        <el-dialog
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">

          <!-- 删除API -->
          <div
            class="changeStatusWrapper"
            v-if="dialogData.type === 'delete'">
            <p class="text">
              删除
              <span class="bold">
                ({{dialogData.info.name}})
              </span>
              API？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="deleteApi()">确认</el-button>
            </div>
          </div>

          <!-- 更新(添加/删除)API -->
          <div v-else>
            <el-form
              label-width="100px"
              :model="dialogData.info">
              <el-form-item label="API名称:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.name"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="类型:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.type"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="地址:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.url"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="参数:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.param"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="请求类型:">
                <div class="inputBox">
                  <el-select class="searchSelect" v-model="dialogData.info.post_type" placeholder="请选择请求类型">
                    <el-option label="get" value="get"></el-option>
                    <el-option label="post" value="post"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="描述:">
                <div class="inputBox">
                  <el-input class="inputDeposit" type="textarea" rows="6" v-model="dialogData.info.desc"></el-input>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button type="primary" @click="updateApi()">确 认</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
  </div>
</template>

<script>
import BreadCrumb from "../../Layout/BreadCrumb.vue"
import { showToast, deepCopy } from "../../../../static/js/utility/utility.js"
  import { systemApi } from "../../../../static/js/api.js"

  export default {
    name: 'APIManage',
    components: {
      BreadCrumb
    },
    data() {
      return {
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // API数据
        apiData: {
          // 分页数据
          paging:{
            page: 1,
            perPage: 10,
            search_str: '',
            post_type: ''
          },
          // API列表
          list: [],
          loading: false
        }
      }
    },
    mounted(){
      this.getApiList()
    },
    created: async function () {
    },
    methods: {
      // 当前页值改变，获取新的客户列表
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.getApiList()
      },
      // 获取API列表
      getApiList: async function name(isSearch) {
        let vm = this
        let data = vm.apiData.paging
        // 搜索列表，page默认为1
        if (isSearch) {
          data.page = 1
        } 
        console.log('this.paging', data)

        let res = await systemApi.getApiList(data)
        console.log('api列表', res.data)
        if (res.meta.code === 200) {
          vm.apiData.list = res.data.list
          vm.apiData.pageCount = res.data.pageCount
          // vm.processData(res.data)
        } else {
          showToast(res.meta.message)
        }
        
      },
      // 操作API信息（添加或修改）dialogData
      operateDialogInfo: function (type, info) {
        let infoNull = {
          id: '' ,
          name: '',
          type: '',
          url: '',
          param: '',
          post_type: '',
          desc: ''
        }
        this.dialogData = {
          type: type,
          title: type === 'add' ? '添加API' : type === 'alter' ? '修改API' : '删除API',
          visible: !(this.dialogData.visible),
          info: info ? deepCopy(info) : infoNull
        }
        console.log('this', this.dialogData)
      },
      // 更新（添加/修改）API
      updateApi: async function () {
        let vm = this
        let data = {
          id: vm.dialogData.info.id,
          name: vm.dialogData.info.name,
          type: vm.dialogData.info.type,
          url: vm.dialogData.info.url,
          param: vm.dialogData.info.param,
          post_type: vm.dialogData.info.post_type,
          desc: vm.dialogData.info.desc
        }

        if (data.name === '') {
          showToast('API名称不能为空！')
          return
        }
        if (data.type === '') {
          showToast('类型不能为空！')
          return
        }
        if (data.url === '') {
          showToast('地址不能为空！')
          return
        }
        if (data.param === '') {
          showToast('参数不能为空！')
          return
        }
        if (data.post_type === '') {
          showToast('请求类型不能为空！')
          return
        }
        if (data.desc === '') {
          showToast('描述不能为空！')
          return
        }

        console.log('更新data', data)
        let res = await systemApi.updateApi(data)
        if (res.meta.code === 200) {
          showToast(data.id === '' ? '添加成功' : '修改成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getApiList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 删除API
      deleteApi: async function () {
        let vm = this
        let data = {
          id: vm.dialogData.info.id
        }

        let res = await systemApi.deleteApi(data)
        if (res.meta.code === 200) {
          showToast('删除成功')
          vm.dialogData.visible = !(vm.dialogData.visible)
          vm.getApiList()
        } else {
          showToast(res.meta.message)
        }
      }
    },
    watch: {
      // 监听搜索字段清空,更新客户列表
      'apiData.paging.search_str': function (newVal) {
        if (newVal === '') {
          this.getApiList()
        }
        console.log('tag', this.apiData.paging.search_str)
      },
      // 监听搜索字段，清空更新客户列表
      'apiData.paging.post_type': function (newVal) {
        if (newVal === '') {
          this.getApiList()
        }
        console.log('tag', this.apiData.paging.post_type)
      },
    }
  }
</script>

<style lang="scss" scoped>
.APIManage {
  .searchArea {
    width: 100%;
    height: 40px;
    .searchInput, .searchSelect {
      width: 200px;
      float: left;
    }
    .searchSelect {
      margin: 0 20px;
    }
    .searchBtn {
      float: left;
    }
  }

  .addBtn {
    margin: 20px 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Page/System/APIManage.vue